import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
import { SafeImage } from './SafeImage';
import { Star, ArrowUpRight, MapPin } from 'lucide-react';
const REVIEWS = [{
  text: 'It felt like a very special place with soul.',
  name: 'Tuval',
  location: 'Tel Aviv-Yafo',
  date: 'December 2025'
}, {
  text: 'Beautiful space — such a peaceful and relaxing retreat.',
  name: 'Teddy',
  location: 'New York',
  date: 'February 2026'
}, {
  text: 'Zev hosted us generously and with genuine warmth.',
  name: 'Meytal',
  location: 'Israel',
  date: 'May 2026'
}, {
  text: 'Perfect for people looking for quiet, nature, and calm.',
  name: 'Yaniv & Yarden',
  location: "Giv'at Shmuel",
  date: 'April 2026'
}, {
  text: 'A beautiful, spacious, homey place surrounded by nature.',
  name: 'Doron',
  location: '',
  date: 'March 2026'
}, {
  text: 'We had a wonderful stay. Such a calm and peaceful atmosphere.',
  name: 'Sari',
  location: '',
  date: 'November 2025'
}, {
  text: "A magical, pastoral place. We'll definitely return.",
  name: 'Orit',
  location: 'Holon',
  date: 'November 2025'
}, {
  text: 'We enjoyed our stay so much. The house is lovely and cozy in a quiet rural setting.',
  name: 'Ayelet',
  location: '',
  date: 'May 2026'
}, {
  text: 'Zev was available, kind, and welcoming. A wonderful place for families.',
  name: 'Noa',
  location: '',
  date: 'May 2026'
}, {
  text: 'A large, private, peaceful space with nature all around.',
  name: 'Tchelet',
  location: '',
  date: 'March 2026'
}, {
  text: 'The ice bath and hot tub were perfect. The host was incredibly friendly.',
  name: 'Michael',
  location: '',
  date: 'December 2025'
}];
const TRUST_STATS = [{
  value: '4.93',
  label: 'Average rating',
  showStars: true
}, {
  value: '89',
  label: 'Airbnb reviews'
}, {
  value: 'Superhost',
  label: '10 years hosting'
}, {
  value: '100%',
  label: 'Response rate'
}];
export function TrustDiscovery() {
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  useEffect(() => {
    if (isPaused) return;
    const interval = setInterval(() => {
      setIndex(i => (i + 1) % REVIEWS.length);
    }, 6500);
    return () => clearInterval(interval);
  }, [isPaused]);
  const current = REVIEWS[index];
  return <section className="py-20 md:py-32 px-6 md:px-12 bg-creamDeep relative" data-id="element-597" data-mp="3ttr73z9id5n2">
      <div className="max-w-5xl mx-auto" data-id="element-598" data-mp="3ouo0wbhsktdi">
        {/* Eyebrow + heading */}
        <FadeIn data-id="element-599" data-mp="3ku43r7x7xprd">
          <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4 text-center" data-id="element-600" data-mp="3kuckxc0djh8d">
            Grounded. Real. Welcoming.
          </p>
        </FadeIn>
        <FadeIn delay={0.1} data-id="element-601" data-mp="29enta7c6du18">
          <h2 className="font-serif text-3xl md:text-4xl text-pine mb-14 text-center max-w-3xl mx-auto" data-id="element-602" data-mp="29eff8c4bgiog">
            Trusted by guests, retreat-goers, and the local community.
          </h2>
        </FadeIn>

        {/* Trust stats row */}
        <FadeIn delay={0.15} data-id="element-603" data-mp="xymjv2e4jtbv">
          <div className="grid grid-cols-2 md:grid-cols-4 border-y border-pine/10 mb-16" data-id="element-604" data-mp="xxbfp1grojk8">
            {TRUST_STATS.map((stat, i) => <div key={stat.label} className={`px-4 py-6 md:py-8 text-center ${i > 0 ? 'md:border-l border-pine/10' : ''} ${i === 1 || i === 3 ? 'border-l border-pine/10 md:border-l' : ''} ${i < 2 ? 'border-b md:border-b-0 border-pine/10' : ''}`} data-id="element-605" data-mp="12r60674752kd" data-mpi={i}>
                {stat.showStars && <div className="flex justify-center gap-0.5 mb-2" data-id="element-606" data-mp="1logwpjyg1hw4">
                    {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-ember text-ember" data-id="element-607" data-mp="3ihabrxip5tuj" data-mpi={j} />)}
                  </div>}
                <div className="font-serif text-2xl md:text-3xl text-pine mb-1" data-id="element-608" data-mp="2s3keodsvrw0z">
                  {stat.value}
                </div>
                <div className="text-xs md:text-sm text-clay/70 uppercase tracking-widest" data-id="element-609" data-mp="2n8esrezhahcw">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </FadeIn>

        {/* Auto-fading review carousel */}
        <div className="relative max-w-3xl mx-auto mb-12 md:mb-16" onMouseEnter={() => setIsPaused(true)} onMouseLeave={() => setIsPaused(false)} data-id="element-610" data-mp="29ffgdluzt39k">
          <div className="min-h-[260px] md:min-h-[220px] flex items-center justify-center" data-id="element-611" data-mp="2j5ijwfzqpzm5">
            <AnimatePresence mode="wait" data-id="element-612" data-mp="2edgxw2crsuix">
              <motion.div key={index} initial={{
              opacity: 0,
              y: 12
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -12
            }} transition={{
              duration: 0.7,
              ease: [0.22, 1, 0.36, 1]
            }} className="text-center" data-id="element-613" data-mp="2ecfkhr8a7vy1">
                <div className="flex justify-center gap-0.5 mb-6" data-id="element-614" data-mp="3sd28k5jear7s">
                  {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-ember text-ember" data-id="element-615" data-mp="jx8urygg7tuf" data-mpi={j} />)}
                </div>
                <blockquote className="font-serif text-2xl md:text-3xl text-pine leading-relaxed mb-6 px-4" data-id="element-616" data-mp="ovaemllp7x6y">
                  "{current.text}"
                </blockquote>
                <p className="text-sm text-clay/80 uppercase tracking-widest" data-id="element-617" data-mp="exnunkpjlfg4">
                  — {current.name}
                  {current.location && <span className="text-clay/50" data-id="element-618" data-mp="2vp5ogqor1drt">, {current.location}</span>}
                  <span className="text-clay/40" data-id="element-619" data-mp="2zmjy2jgcdnkc"> · {current.date}</span>
                </p>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Pagination dots */}
          <div className="flex justify-center gap-1.5 mt-8" data-id="element-620" data-mp="118xkkkkls929">
            {REVIEWS.map((_, i) => <button key={i} onClick={() => setIndex(i)} aria-label={`Show review ${i + 1}`} className={`h-1 rounded-full transition-all duration-500 ${i === index ? 'w-8 bg-pine' : 'w-1 bg-pine/25 hover:bg-pine/50'}`} data-id="element-621" data-mp="we1foju9pr7q" data-mpi={i} />)}
          </div>
        </div>

        {/* Community portraits */}
        <FadeIn delay={0.2} data-id="element-622" data-mp="dhs3y36u9cqw">
          <div className="grid grid-cols-2 gap-3 md:gap-4 mb-12" data-id="element-623" data-mp="dj36y0sgmggy">
            <div className="aspect-[4/3] overflow-hidden rounded-sm" data-id="element-624" data-mp="8jqcouz9e74c">
              <SafeImage src="https://cdn.magicpatterns.com/uploads/7Qys8tKbwECbxzbYaa92kV/472354039_122134502762570946_1769931133132476279_n.jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/kEWdox2XZmrj2PeAtGRtko/549193096_122201298908570946_2685253799441819983_n.jpg" alt="Community at Pines Retreat" className="w-full h-full object-cover" data-id="element-625" data-mp="27vj9orm1rch2" />
            </div>
            <div className="aspect-[4/3] overflow-hidden rounded-sm" data-id="element-626" data-mp="2k7lq5fdhuvld">
              <SafeImage src="https://cdn.magicpatterns.com/uploads/qXcBW7hzvo5ydv3ghCCSz3/472500973_122134502894570946_1805971770703857489_n.jpg" fallbackSrc="https://cdn.magicpatterns.com/uploads/7Qys8tKbwECbxzbYaa92kV/472354039_122134502762570946_1769931133132476279_n.jpg" alt="Community at Pines Retreat" className="w-full h-full object-cover" data-id="element-627" data-mp="2p3akn4anpmat" />
            </div>
          </div>
        </FadeIn>

        {/* Tag chips */}
        <FadeIn delay={0.25} data-id="element-628" data-mp="3ctobwslf3h4c">
          <div className="flex flex-wrap justify-center gap-2 mb-12" data-id="element-629" data-mp="3cwk9gftcs3s9">
            {['Retreats', 'Workshops', 'Private Events', 'Overnight Stay'].map(tag => <span key={tag} className="px-4 py-2 bg-cream border border-pine/15 text-pine text-sm rounded-full" data-id="element-630" data-mp="6s76e76q8t5v">
                  {tag}
                </span>)}
          </div>
        </FadeIn>

        {/* Read all reviews + Google links */}
        <FadeIn delay={0.3} data-id="element-631" data-mp="qfwrjvk5rv64">
          <div className="flex flex-col sm:flex-row justify-center items-stretch sm:items-center gap-3" data-id="element-632" data-mp="qf58fk7qzpwq">
            <a href={LINKS.airbnb} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-pine text-cream rounded-sm font-medium tracking-wide hover:bg-pineDeep transition-colors" data-id="element-633" data-mp="lhmyprlwp6no">
              Read all 89 reviews on Airbnb
              <ArrowUpRight className="w-4 h-4 opacity-80" data-id="element-634" data-mp="319svsuqpdxjo" />
            </a>
            <a href={LINKS.googleMaps} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-transparent border border-pine/25 text-pine rounded-sm font-medium tracking-wide hover:bg-pine/5 hover:border-pine/40 transition-colors" data-id="element-635" data-mp="2wag1xq1ezq7l">
              <MapPin className="w-4 h-4" data-id="element-636" data-mp="16zm5l1l5971m" />
              Find us on Google
            </a>
          </div>
        </FadeIn>
      </div>
    </section>;
}